<template>
    <rkm-overlay>
         <rkm-layout-body title='Exames imagem'>
            <template
                v-if="loaded"
                v-slot:center
            >
                <rkm-button
                    v-if="model.alergias.length > 0"
                    @click="scrollToAlergias"
                    color="alergia"
                >
                    Paciente alérgico
                </rkm-button>
            </template>

            <template
                v-if="loaded"
                v-slot:actions
            >
                <rkm-button
                    color="danger"
                    @click.stop="exit()"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="form.recepcao.isEncaminhamento && !additionals.hasAtendimentoMedico"
                    @click.stop="$refs.Form.liberaPaciente()"
                    color="success"
                    outline
                >
                    Paciente Liberado
                </rkm-button>

                <rkm-button
                    @click.stop="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <template
                v-if="paciente"
                v-slot:subtitle
            >

                <div class="sub-title">
                    <rkm-icon class="icon" icon="user"/>
                    <span class="text-uppercase" v-if="paciente.preferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                        {{ paciente.nome }} <strong>({{ paciente.nomeSocial }})</strong>,
                    </span>
                    <span class="text-uppercase" v-else>
                        {{ paciente.nome }},
                    </span>
                    <span v-if="paciente.idade">
                        {{ paciente.idade.anos }} anos,
                        {{ paciente.idade.meses }} meses
                        e {{ paciente.idade.dias }} dias,
                    </span>
                    <span>{{ paciente.sexo.descricao }}</span>
                </div>
            </template>

            <rkm-layout-content v-if="loaded">
                <Form
                    ref="Form"
                    :plantao-id="$route.params.plantaoId"
                    :data="{ form, model, additionals }"
                    @save="redirectToList()"
                />
            </rkm-layout-content>
         </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Mixins
import { error, repository } from '@/mixins'

// Components.
import Form from '@/components/pronto-atendimento/atendimento-exame-imagem/Form'

// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            exameImagem: this.getConectaSusRepository('prontoAtendimento.exameImagem'),
            fila: this.getConectaSusRepository('prontoAtendimento.fila')
        }

        this.load()
    },
    data: () => ({
        form: null,
        model: null,
        additionals: null,
        paciente: null,
        loaded: false,
        enums: { preferenciaNome }
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'unsetLoading',
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
        ]),
        load() {

            this.setLoading()

            this.repositories.exameImagem.create(this.$route.params.id).then(response => {

                this.form = response.data.form
                this.model = response.data.model
                this.additionals = response.data.additionals
                this.paciente = response.data.form.paciente

                this.loaded = true
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        scrollToAlergias() {

            const element = document.querySelector('#alergias')

            element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        },
        exit() {

            this.showExitConfirmation(async () => {

                this.setLoading()

                return this.repositories.fila.sendBack(this.$route.params.id)
                    .then(() => this.redirectToList())
                    .finally(() => this.unsetLoading())
            }, this.handleError)
        },
        redirectToList() {

            this.unsetShowExitFormConfirmation()

            this.$router.push({
                name: this.additionals.isPacienteEmObservacao
                    ? 'pronto-atendimento-paciente-observacao-index'
                    : 'pronto-atendimento-exame-imagem-index'
            }).catch(() => {})
        },
    },
    mixins: [ error, repository ],
}
</script>

<style scoped>
.sub-title {
    font-size: 13px;
    text-transform: uppercase;
    color: #222;
}
</style>